<template>
	<div class="ml-4 mr-4">
		<v-select
          :items="listOfLists"
          v-model="selectedList"
          item-text="listname"
          item-value="listname"
          @change="getList"
          outline
          return-object
          label="Select Amenity List">
        </v-select>
        <v-card v-if="amenities" class="pb-5">
        	<v-toolbar
		      color="indigo lighten-3" style="color: #222222;"
		      
		    >
		      <v-toolbar-title>{{selectedList.listname }}</v-toolbar-title>
		      <v-spacer></v-spacer>
			  <v-tooltip right>
			    <v-btn 	small fab color="grey lighten-1" 
					@click="showDeleteDialog = true"
					slot="activator"
					v-if="listHasValues"
					depressed class="ml-4" style="margin-top: 10px;">
				<v-icon>layers_clear</v-icon>
				</v-btn>
				<span>Clear Values</span>
			  </v-tooltip>
		    </v-toolbar>

			  <v-dialog v-model="showDeleteDialog" persistent max-width="390">					                                
                                <v-card class="pl-2 pt-1 pr-2">
                                    <v-card-title class="headline">Confirm Amenities Deletion</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text class="pt-4 body-2">All Values for {{selectedList.listname }} will be cleared for this room.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" flat @click.native="showDeleteDialog = false">Cancel</v-btn>
                                        <v-btn color="green darken-1" flat 
                                            @click.native="showDeleteDialog = false; clearAmenities()">Delete
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

        <span class="ml-2 title"> </span>
        
        <!-- Quick Room Picker for phone view -->
        <v-flex v-if="$vuetify.breakpoint.xsOnly" class="mx-4"> 
					<!-- type="number" helps with phone keyboard but prevents correct display -->
				<v-autocomplete					
					ref="roomselect"
					type="number"
					v-model="selectedRoom"
					item-text="number"
					autocomplete
					outline
					:items="roomItems"
					single-line
					label="Room"
					@change="closeKeyboard"
				>
					<template slot="selection" slot-scope="{ item, tile }">
							<v-layout>
							<v-list-tile-avatar dark tile color="grey darken-3" style="color: white; margin-top:5px;">
								{{selectedBuilding.bldgAlpha}}
							</v-list-tile-avatar>
							<v-list-tile-content>
							  <v-list-tile >
								{{item.number}}
							  </v-list-tile>
							</v-list-tile-content>
							</v-layout>
						  </template>
						<template slot="item" slot-scope="{ item, tile }">
							<v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
								{{selectedBuilding.bldgAlpha}}
							</v-list-tile-avatar>
							<v-list-tile-content>
							  <v-list-tile-title>
								{{item.number}}
							  </v-list-tile-title>
							</v-list-tile-content>
						  </template>
				</v-autocomplete>
		</v-flex>


		<v-layout :key="reset" class="mt-3" justify-center>
			<v-btn v-if="!showList" @click="initiateList">
				Populate Amenities
			</v-btn>
		</v-layout>

		<v-layout column v-if="showList" class="pl-2 pr-3">
			
			
			<div style="width: 100%;" class="subheading">
				<v-form v-model="valid" ref="form">
				<div v-for="(item, index) in sortedItems" :key="index" >	
		    		<v-layout class="mt-1 mb-1" row fill-height align-center justify-space-between>		        		
		        		<v-flex xs6>
		        			<v-text-field 
			        			v-model="item.label"
		        				:label="item.label ? '' : 'Label'"
		        				flat solo
					            readonly
					            >
						    </v-text-field>
						</v-flex>
		        		<v-flex xs6 class="pl-2">
		        			<v-checkbox v-if="item.dataType == 'Boolean'"
		        				class="right"
						      	v-model="item.value"
						      	true-value="1"
						      	false-value="0"
						      	:readonly="!allowedEdit"
						      	@change="changed = true">
		        			</v-checkbox>
		        		<v-text-field 
		        				v-if="item.dataType == 'String' || item.dataType == 'Number' || item.dataType == 'Integer'"
		        				v-model="item.value" 
		        				:readonly="!allowedEdit"
		        				@input="changed = true"
		        				:rules="rules(item.dataType)"
		        				reverse
		        				outline
		        				class="pl-2">
	        			</v-text-field>
	        			<v-text-field v-if="item.dataType == 'Date'"
		        				v-model="item.value" 
		        				:readonly="!allowedEdit"
		        				@input="changed = true"
		        				:rules="rules(item.dataType)"
		        				reverse
		        				outline
		        				class="pl-2">
	        			</v-text-field>
	        			<v-select v-if="item.dataType == 'Allowed Values'"
		        				v-model="item.value" 
		        				:items="item.allowedValues.map((item) => item.value )"
		        				:readonly="!allowedEdit"
		        				@input="changed = true"
		        				hide-details		        				
		        				outline
		        				class="pl-2">
	        			</v-select>
	        			

	        			</v-flex>
		        	</v-layout>
		        	<div class="ml-2 mr-1" style="border-width: 0px; border-bottom-width: 1px; border-style: solid; border-color: #AAAAAA;"></div>
		        </div>
		   		</v-form>
		    </div>
			
		    <v-layout v-if="changed && allowedEdit" row class="ml-3 mr-1">
		    	<v-flex class="mr-3"><v-btn color="#a70000" dark block class="mt-4 mx" @click="submit">Save Changes</v-btn></v-flex>
		    	<v-flex><v-btn color="#a70000" dark block class="mt-4 mx-0" @click="getList">Cancel</v-btn></v-flex>
			</v-layout>
		</v-layout>
		</v-card>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { NETID_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'
import moment from 'moment'

export default {
data () {
	return {
		valid: false,
		listOfLists: 		[],
		selectedList: 	null,	
		amenities: 			null,
		showEmptyList: 		false, 
		changed: 			false,
		reset: 1,
		requiredRules:  [	v => !!v || "Field is required", ],
		showDeleteDialog: false,
	}
},

watch: {
		selectedRoom (val) { this.getList() },
},

created: async function () {
	this.listOfLists = await this.fetchAmenitiesListOfLists({ roomKey: this.selectedRoom.roomKey })
	//console.log(this.listOfLists)
},

computed: {
	...mapState({   	buildings: 				state => state.space.buildings,
						selectedBuilding: 		state => state.space.selectedBuilding,
						//selectedRoom: 			state => state.space.selectedRoom,
						roomAmenitySidebarOpen: state => state.ui.roomAmenitySidebarOpen,
						isSuperUser:  			state => state.user.isSuperUser,

				}),

	// Clicking the Initiate button will force showing of an empty list
	showList: function () {
		return (this.listHasValues  || this.showEmptyList) ? true : false
	},

	listHasValues: function () {
		let retValue = false
		this.amenities && this.amenities.list.forEach((row) => {
			if (row.value) { retValue = true }
		})
		return retValue
	},

	allowedEdit: function () {
		// Allow edit if logged in user is owner or in array of editors
		let netId = jscookie.get(NETID_COOKIE)
		if (this.isSuperUser || this.selectedList.owner == netId) { return true}
			this.selectedList.editors.forEach((editor) => { 
				if (editor.netid == netId) { return true }
			})
		return false
	},

	selectedRoom : {
		get () {
			return this.$store.state.space.selectedRoom // ? this.$store.state.space.selectedRoom.number : null
		},
		set (value) {
			//this.updateSelectionCentering(true)
			this.fetchFullRoom({bldgAlpha: this.selectedBuilding.bldgAlpha, number: value})  // This sets selectedRoom in action
		}
	},

	roomItems : function () {
	  return this.$store.state.space.buildingRooms // this.$store.state.space.buildingRooms.map((room) => {return room.number})

	},

	sortedItems: function () {
		return this.amenities.list.sort((a, b) => (a.order > b.order) ? 1 : -1)

	}

	
},

methods : {
	...mapMutations([ 	'setBuildings', 'setSnackText',	''				]),
	
	...mapActions  ([	'updateRoomAmenitiesList', 'fetchAmenitiesList', 'fetchAmenitiesListOfLists', 'fetchFullRoom', 'clearRoomAmenitiesDataSingleRoom'	]),

	getList : async function () {
		this.refresh()
		if (!this.selectedList) { return }		
		//console.log("SelectedRoom: ", this.selectedRoom)
		let payload = { key: this.selectedList.key, listname: this.selectedList.listname, roomKey: this.selectedRoom.roomKey }
		//console.log("fetching Amenity List: ", payload)
		this.amenities = await this.fetchAmenitiesList(payload)
	},

	initiateList : function (value) {
		this.showEmptyList = true
	},

	rules: function (dataType) {
		if (dataType=='Boolean') { 
			return [ v => !!v || "Field is required", ] 
		}
		if (dataType=='Number') { 
			return [ v => !isNaN(v) || !v || 'Must be a number.', ] 
		}
		if (dataType=='Integer') { 
			return [ v => this.isInteger(v) || !v || 'Must be an Integer.', ] 
		}
		if (dataType=='Date') { 
			return [ v => this.isDate(v) || !v || 'Must be a Date. MM/DD/YYYY', ] 
		}
	},

	isInteger: function (str) {
	    var n = Math.floor(Number(str));
	    return n !== Infinity && String(n) === str && n >= 0;
	},

	isDate: function (str) {
		return moment(str, "MM/DD/YYYY", true).isValid()
	},

	submit: async function () {  
		if (!this.valid) { console.log("Form Not Valid"); return }
		let payload = { key: this.amenities.key, listname: this.amenities.listname, roomKey: this.selectedRoom.roomKey, list: this.amenities.list }
		//console.log("Submit", payload)
		let response = await this.updateRoomAmenitiesList(payload)
		this.setSnackText(response)
		this.changed = false
	},

	refresh: function () {
		this.reset = this.reset +1
		this.showEmptyList = false
		this.changed = false
	},

	closeKeyboard () {
	  this.$refs.roomselect.blur()
	},

	clearAmenities: async function () {
		let payload = { key: this.amenities.key, roomKey: this.selectedRoom.roomKey }
		let response = await this.clearRoomAmenitiesDataSingleRoom(payload)
		this.setSnackText(response)
		this.refresh()
		this.selectedList = null
		this.amenities = null
	}

	
},

}

</script>

<style>

.right.v-input--selection-controls {
	float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/roomAmenities/RoomAmenitiesSidebarContent.vue